import { SERVERLESS_PREFIX } from '../../utils';
export const getInitialAppInstallationDataUrl = _ref => {
  let {
    appId,
    version,
    tenantId,
    shareUrlId,
    isOneStepInstall
  } = _ref;
  const urlParams = new URLSearchParams({
    appId,
    tenantId,
    ...(version ? {
      version
    } : {}),
    ...(shareUrlId ? {
      shareUrlId
    } : {}),
    ...(isOneStepInstall ? {
      shouldFetchPermissions: 'false'
    } : {})
  }).toString();
  return `${SERVERLESS_PREFIX}/getAppInstallationData?${urlParams}`;
};
//# sourceMappingURL=getInitialAppInstallationDataUrl.js.map